export default {
  groups: {
    dashboards: 'Pulpity',
    online_shop: 'Sklep internetowy',
    home: 'Strona główna',
    marketing: 'Marketing',
    reservations: 'Rezerwacje',
    website: 'Strona internetowa',
    orders_portal: 'Otwórz portal zamówień',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Aplikacja mobilna',
    phone_answering: 'Odbieranie telefonów',
    pricing: 'Cennik',
    team: 'Zespół',
    data_deletion_requests: 'Żądania usunięcia danych',
    partner: 'Partner',
  },
  get_started: {
    title: 'Pierwsze kroki',
  },
  onboarding: {
    title: 'Uruchomienie',
  },
  new_restaurant: {
    title: 'Nowa restauracja',
  },
  gift_cards: {
    title: 'Karty podarunkowe',
  },
  top_items: {
    title: 'Najpopularniejsze',
  },
  dashboards: {
    title: 'Pulpity',
    children: {
      general: 'Ogólne',
      restaurant_details: 'Szczegóły restauracji',
      external_delivery: 'Dostawa zewnętrzna',
      overview: 'Przegląd',
      orders: 'Zamówienia według źródła',
      google: 'Google',
      customers: 'Klienci',
    },
  },
  customer_base: {
    title: 'Baza klientów',
  },
  new_company: {
    title: 'Nowa restauracja',
  },
  agent_ops_queue: {
    title: 'Sugestie AI',
  },
  external_delivery_support: {
    title: 'Wsparcie dostawy zewnętrznej',
  },
  payment_gateways: {
    title: 'Bramki płatności',
  },
  developers: {
    title: 'Deweloperzy',
  },
  feature_flags: {
    title: 'Flagi funkcji',
  },
  test_restaurants: {
    title: 'Restauracje testowe',
  },
  partners: {
    title: 'Partnerzy',
  },
  partner: {
    children: {
      account: 'Konto',
      branding: 'Branding',
      payment_gateway: 'Bramka płatnicza',
      billing: 'Płatności',
      tax_currency: 'Podatki i waluta',
      service_fee_calculator: 'Kalkulator opłaty serwisowej',
      processing_fees: 'Opłaty za przetwarzanie',
    },
  },
  going_live: {
    title: 'Uruchomienie',
    children: {
      setup_package_fulfillments: 'Realizacje Logsta',
      polygraphy: 'Produkty drukowane',
    },
  },
  franchises: {
    title: 'Marki',
  },
  setup_package_fulfillments: {
    title: 'Realizacje pakietu konfiguracyjnego',
  },
  website: {
    title: 'Strona internetowa',
    children: {
      storefront: 'Sklep internetowy',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Rezerwacja',
    children: {
      overview: 'Przegląd',
      booking_availability: 'Dostępność rezerwacji',
      settings: 'Ustawienia',
      general: 'Ogólne',
      storefront: 'Sklep internetowy',
    },
  },
  subscriptions: {
    title: 'Subskrypcje',
    children: {
      subscriptions: 'Subskrypcje',
      products: 'Produkty',
    },
  },
  sales: {
    title: 'Sprzedaż',
    children: {
      orders: 'Zamówienia',
      receipts: 'Paragony dla klientów',
      external_deliveries: 'Dostawy zewnętrzne',
    },
  },
  billing: {
    title: 'Raporty',
    children: {
      monthly_statements: 'Zestawienia miesięczne',
      payouts: 'Wypłaty',
      invoices: 'Faktury',
      subscription: 'Subskrypcja',
      sales_summary: 'Podsumowanie sprzedaży',
      internal_invoice_items: 'Wewnętrzne pozycje faktur',
      income_reports: 'Raporty przychodów',
      tax_reports: 'Raporty podatkowe',
    },
  },
  master_menu: {
    title: 'Synchronizacja marki',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Marki',
      manage_menus: 'Zarządzaj menu',
      modifiers: 'Modyfikatory',
      smart_pricing: 'Inteligentne ceny',
      upsell_items: 'Pozycje upsell',
      sold_out_items: 'Pozycje wyprzedane',
      import: 'Import',
      edit_history: 'Historia edycji',
    },
  },
  my_store: {
    title: 'Moje dane',
    children: {
      settings: 'Profil',
      gallery: 'Galeria',
      business_information: 'Informacje o firmie',
      documents: 'Moje dokumenty',
      personal_information: 'Dane osobowe',
      bank_info: 'Dane bankowe',
      tax_info: 'Dane podatkowe',
      shipping_info: 'Dane wysyłki',
      google_profile: 'Profil Google',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Nota prawna',
      post_launch: 'Po uruchomieniu',
      tax_currency: 'Podatki i waluta',
    },
  },
  opening_hours: {
    title: 'Godziny otwarcia i lokalizacja',
    children: {
      opening_hours: 'Godziny otwarcia',
      location: 'Lokalizacja',
    },
  },
  order_settings: {
    title: 'Ustawienia zamówień',
    children: {
      takeout: 'Metody zamówień',
      order_layout: 'Układ zamówienia',
      payment_methods: 'Metody płatności',
      connect_paypal: 'Połącz PayPal',
      tips: 'Napiwki',
      service_fee: 'Opłaty',
      processing_fees: 'Opłaty za przetwarzanie',
      receipt: 'Paragon',
      staff_credentials: 'Dane logowania personelu',
      integrations: 'Integracje',
      terminal: 'Terminal',
      invoices: 'Faktury',
    },
  },
  mobile_app: {
    title: 'Aplikacja mobilna',
    children: {
      overview: 'Przegląd',
      updates: 'Aktualizacje',
      intro_screen: 'Ekran powitalny',
    },
  },
  marketing: {
    children: {
      overview: 'Przegląd',
      followers: 'Obserwujący',
      email_messages: 'Wiadomości e-mail',
      push_notifications: 'Powiadomienia push',
      promo_codes: 'Kody promocyjne',
      offers: 'Oferty',
      google_business: 'Google Business',
      google_review_program: 'Program recenzji Google',
      loyalty_program: 'Program lojalnościowy',
      polygraphy: 'Produkty drukowane',
      tracking_links: 'Linki śledzące',
      google_ads: 'Google Ads',
      website_analytics: 'Analityka strony',
      featured_posts: 'Posty w aplikacji mobilnej',
    },
  },
  loyalty_tablet: {
    title: 'Tablet lojalnościowy',
    children: {
      dashboard: 'Panel',
      settings: 'Ustawienia',
      credentials: 'Dane logowania',
    },
  },
  contract: {
    title: 'Umowa',
    children: {
      agreement: 'Porozumienie',
      template: 'Szablon',
    },
  },
  team: {
    children: {
      managers: 'Menedżerowie',
      reports: 'Raporty',
    },
  },
};
